export const TOOTH_POSITIONS = {
    "18": {
        label: "Structure of permanent maxillary right third molar tooth",
        code_position: "68085002"
    },
    "17": {
        label: "Structure of permanent maxillary right second molar tooth",
        code_position: "863902006"
    },
    "16": {
        label: "Structure of permanent maxillary right first molar tooth",
        code_position: "865995000"
    },
    "15": {
        label: "Structure of permanent maxillary right second premolar tooth",
        code_position: "36492000"
    },
    "14": {
        label: "Structure of permanent maxillary right first premolar tooth",
        code_position: "57826002"
    },
    "13": {
        label: "Structure of permanent maxillary right canine tooth",
        code_position: "860767006"
    },
    "12": {
        label: "Structure of permanent maxillary right lateral incisor tooth",
        code_position: "424877001"
    },
    "11": {
        label: "Structure of permanent maxillary right central incisor tooth",
        code_position: "422653006"
    },



    "21": {
        label: "Structure of permanent maxillary left central incisor tooth",
        code_position: "424399000"
    },
    "22": {
        label: "Structure of permanent maxillary left lateral incisor tooth",
        code_position: "423185002"
    },
    "23": {
        label: "Structure of permanent maxillary left canine tooth",
        code_position: "860780009"
    },
    "24": {
        label: "Structure of permanent maxillary left first premolar tooth",
        code_position: "61897005"
    },
    "25": {
        label: "Structure of permanent maxillary left second premolar tooth",
        code_position: "23226009"
    },
    "26": {
        label: "Structure of permanent maxillary left first molar tooth",
        code_position: "865988009"
    },
    "27": {
        label: "Structure of permanent maxillary left second molar tooth",
        code_position: "863901004"
    },
    "28": {
        label: "Structure of permanent maxillary left third molar tooth",
        code_position: "87704003"
    },


    "31": {
        label: "Structure of permanent mandibular left central incisor tooth",
        code_position: "425106001"
    },
    "32": {
        label: "Structure of permanent mandibular left lateral incisor tooth",
        code_position: "423331005"
    },
    "33": {
        label: "Structure of permanent mandibular left canine tooth",
        code_position: "860782001"
    },
    "34": {
        label: "Structure of permanent mandibular left first premolar tooth",
        code_position: "2400006"
    },
    "35": {
        label: "Structure of permanent mandibular left second premolar tooth",
        code_position: "24573005"
    },
    "36": {
        label: "Structure of permanent mandibular left first molar tooth",
        code_position: "866006002"
    },
    "37": {
        label: "Structure of permanent mandibular left second molar tooth",
        code_position: "863898000"
    },
    "38": {
        label: "Structure of permanent mandibular left third molar tooth",
        code_position: "74344005"
    },



    "41": {
        label: "Structure of permanent mandibular right central incisor tooth",
        code_position: "425106001"
    },
    "42": {
        label: "Structure of permanent mandibular right lateral incisor tooth",
        code_position: "423331005"
    },
    "43": {
        label: "Structure of permanent mandibular right canine tooth",
        code_position: "860782001"
    },
    "44": {
        label: "Structure of permanent mandibular right first premolar tooth",
        code_position: "2400006"
    },
    "45": {
        label: "Structure of permanent mandibular right second premolar tooth",
        code_position: "24573005"
    },
    "46": {
        label: "Structure of permanent mandibular right first molar tooth",
        code_position: "866006002"
    },
    "47": {
        label: "Structure of permanent mandibular right second molar tooth",
        code_position: "863898000"
    },
    "48": {
        label: "Structure of permanent mandibular right third molar tooth",
        code_position: "74344005"
    },



    "55": {
        label: "Structure of primary maxillary right second molar tooth",
        code_position: "27855007"
    },
    "54": {
        label: "Structure of primary maxillary right first molar tooth",
        code_position: "17505006"
    },
    "53": {
        label: "Structure of primary maxillary right canine tooth",
        code_position: "30618001"
    },
    "52": {
        label: "Structure of primary maxillary right lateral incisor tooth",
        code_position: "65624003"
    },
    "51": {
        label: "Structure of primary maxillary right central incisor tooth",
        code_position: "88824007"
    },



    "61": {
        label: "Structure of primary maxillary left central incisor tooth",
        code_position: "51678005"
    },
    "62": {
        label: "Structure of primary maxillary left lateral incisor tooth",
        code_position: "43622005"
    },
    "63": {
        label: "Structure of primary maxillary left canine tooth",
        code_position: "73937000"
    },
    "64": {
        label: "Structure of primary maxillary left first molar tooth",
        code_position: "45234009"
    },
    "65": {
        label: "Structure of primary maxillary left second molar tooth",
        code_position: "51943008"
    },



    "71": {
        label: "Structure of primary mandibular left central incisor tooth",
        code_position: "89552004"
    },
    "72": {
        label: "Structure of primary mandibular left lateral incisor tooth",
        code_position: "14770005"
    },
    "73": {
        label: "Structure of primary mandibular left canine tooth",
        code_position: "43281008"
    },
    "74": {
        label: "Structure of primary mandibular left first molar tooth",
        code_position: "38896004"
    },
    "75": {
        label: "Structure of primary mandibular left second molar tooth",
        code_position: "49330006"
    },


    "81": {
        label: "Structure of primary mandibular right central incisor tooth",
        code_position: "67834006"
    },
    "82": {
        label: "Structure of primary mandibular right lateral incisor tooth",
        code_position: "22445006"
    },
    "83": {
        label: "Structure of primary mandibular right canine tooth",
        code_position: "6062009"
    },
    "84": {
        label: "Structure of primary mandibular right first molar tooth",
        code_position: "58646007"
    },
    "85": {
        label: "Structure of primary mandibular right second molar tooth",
        code_position: "61868007"
    },
}